import classNames from 'classnames';

interface EditIconProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'onClick'> {
  size?: number;
  onClick?: (event) => void;
}

export default function EditIcon({ size = 36, className = '', onClick, ...rest }: EditIconProps) {
  return (
    <span {...rest} className={classNames('flex items-center', className)} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19 3.17188C18.7599 3.17188 18.5222 3.21917 18.3003 3.31106C18.0785 3.40294 17.8769 3.53762 17.7071 3.70741L4.39491 17.0196L3.42524 20.5751L6.9807 19.6054L20.2929 6.2932C20.4627 6.12341 20.5974 5.92184 20.6893 5.70001C20.7812 5.47818 20.8284 5.24042 20.8284 5.0003C20.8284 4.76019 20.7812 4.52243 20.6893 4.30059C20.5974 4.07876 20.4627 3.87719 20.2929 3.70741C20.1231 3.53762 19.9216 3.40294 19.6997 3.31106C19.4779 3.21917 19.2401 3.17188 19 3.17188ZM17.5349 1.4633C17.9994 1.2709 18.4973 1.17188 19 1.17188C19.5028 1.17188 20.0006 1.2709 20.4651 1.4633C20.9296 1.65569 21.3516 1.93769 21.7071 2.2932C22.0626 2.6487 22.3446 3.07074 22.537 3.53523C22.7294 3.99972 22.8284 4.49755 22.8284 5.0003C22.8284 5.50306 22.7294 6.00089 22.537 6.46538C22.3446 6.92986 22.0626 7.35191 21.7071 7.70741L8.20713 21.2074C8.08407 21.3305 7.93104 21.4193 7.76314 21.4651L2.26314 22.9651C1.91693 23.0595 1.54667 22.9612 1.29292 22.7074C1.03917 22.4537 0.940838 22.0834 1.03526 21.7372L2.53526 16.2372C2.58105 16.0693 2.66986 15.9163 2.79292 15.7932L16.2929 2.2932C16.6484 1.93769 17.0705 1.65569 17.5349 1.4633Z'
        />
      </svg>
    </span>
  );
}
